import React from 'react';

interface SectionLabelProps {
    children: React.ReactNode;
    /**
     * Bootstrap spacing utility classes, e.g. "mb-3", "mb-4".
     * No default margin — spacing is caller's responsibility.
     */
    className?: string;
    [key: string]: unknown;
}

/**
 * Uppercase section label — Bootstrap 5 / theme-aware, no hardcoded colours.
 * Uses `var(--bs-secondary-color)` so it respects the active Bootstrap theme.
 */
export const SectionLabel: React.FC<SectionLabelProps> = ({ children, className = '', ...rest }) => (
    <p
        className={className}
        style={{
            fontSize: '11px',
            fontWeight: 700,
            color: 'var(--bs-secondary-color)',
            textTransform: 'uppercase',
            letterSpacing: '0.6px',
            marginBottom: 0,
        }}
        {...rest}
    >
        {children}
    </p>
);

export default SectionLabel;
